module.exports = __webpack_public_path__ + "static/media/7_Chime-Switch-Digital.244d6325.svg";